<template>
  <el-dialog title="卡片详情"
             :visible.sync="dialogShow"
             width="600px"
             :modal-append-to-body="false"
             @close="closeDialog">
    <el-collapse v-model="activeNames" style="padding-left: 30px;">
      <!-- 卡片信息 -->
      <el-collapse-item title="卡片信息" name="1">
        <div class="info-item">
          <span class="label">{{ $t('text.status') }}</span>
          <el-tag size="medium"
                  :type="form.status === '00'
                               ? 'info'
                               : form.status === '02'
                               ? 'danger'
                               : form.status === '03'
                               ? 'success'
                               : 'primary'">

            {{
              form.status === '00' ? $t('cardStatus.00') : (form.status === '02' ? $t('cardStatus.02') : (form.status === '03' ? $t('cardStatus.03') : $t('cardStatus.01')))
            }}
          </el-tag>
        </div>

        <div class="info-item">
          <div class="detail-right">
            <span class="label">{{ $t('text.cardName') }}</span>
            {{ form.receiverCardAccount + '-' + getCardTypeName(form.cardType) }}
            <i class="el-icon-copy-document"
               v-copy=" form.receiverCardAccount + '-' + getCardTypeName(form.cardType)"></i>
          </div>
        </div>

        <div class="info-item">
          <span class="label">{{ $t('text.cardType')  }}</span>
          {{ getCardTypeName(form.cardType) }}
        </div>

        <div class="info-item">
          <span class="label">{{ $t('text.upstreamAbridge') }}</span>
          {{ getReceiverCardOrganizationName(form.receiverCardOrganization) }}
        </div>

        <div class="info-item">
          <span class="label">使用权重</span>
          {{ form.priority }}
        </div>

        <div class="info-item">
          <div class="detail-right">
            <span class="label">{{ $t('text.cardholderName') }}</span>
            {{ form.receiverName }}
            <i class="el-icon-copy-document" v-copy=" form.receiverName"></i>
          </div>
        </div>

        <div class="info-item">
          <div class="detail-right">
            <span class="label">账号</span>
            {{ form.receiverCardAccount }}
            <i class="el-icon-copy-document" v-copy=" form.receiverCardAccount "></i>
          </div>
        </div>

        <div class="info-item">
          <div class="detail-right">
            <span class="label">设备号</span>
            {{ form.deviceId }}
            <i class="el-icon-copy-document" v-copy=" form.deviceId"></i>
          </div>
        </div>
      </el-collapse-item>

      <!-- 卡片额度 -->
      <el-collapse-item title="卡片额度" name="2">
        <div class="info-item">
          <span class="label2">最小交易额(PKR)</span>
          {{ $formatter.YuanToThousandth(null, null, form.minAmount, null) }}
        </div>

        <div class="info-item">
          <span class="label2">最大交易额(PKR)</span>
          {{ $formatter.YuanToThousandth(null, null, form.maxAmount, null) }}
        </div>

        <div class="quota-info-item" v-if="form.monthQuota && form.monthQuota>0">
          <span class="label2">可用额度(PKR)</span>
          <div class="orderStyle" style="margin-bottom: 0" v-if="form.monthQuota && form.monthQuota>0">
            {{ $t('status.month') }}: {{ $formatter.YuanToThousandth(null, null, form.monthQuota, null) }} / <i
              style="color:#67C23A">{{ $t('text.used') }}
            {{ $formatter.YuanToThousandth(null, null, form.remainingMonthQuota, null) }}</i>
          </div>
        </div>

        <div class="quota-info-item">
          <span class="label2"></span>
          <div class="orderStyle" style="margin-bottom: 0" v-if="form.yearQuota && form.yearQuota>0">
            {{ $t('status.year') }} : {{ $formatter.YuanToThousandth(null, null, form.yearQuota, null) }} / <i style="color:#67C23A">{{ $t('text.used') }}
            : {{ $formatter.YuanToThousandth(null, null, form.remainingMonthQuota, null) }}</i>
          </div>
        </div>

        <div class="quota-info-item" v-if="form.weekQuota && form.weekQuota>0">
          <span class="label2"></span>
          <div class="orderStyle" style="margin-bottom: 0" v-if="form.weekQuota && form.weekQuota>0">
            {{ $t('status.week') }} : {{ $formatter.YuanToThousandth(null, null, form.weekQuota, null) }} / <i style="color:#67C23A">{{ $t('text.used') }}
            : {{ $formatter.YuanToThousandth(null, null, form.remainingMonthQuota, null) }}</i>
          </div>
        </div>

        <div class="quota-info-item" v-if="form.dailyQuota && form.dailyQuota>0">
          <span class="label2"></span>
          <div class="orderStyle" style="margin-bottom: 0" v-if="form.dailyQuota && form.dailyQuota>0">
            {{ $t('status.day') }} : {{ $formatter.YuanToThousandth(null, null, form.dailyQuota, null) }} / <i
              style="color:#67C23A">{{ $t('text.used') }}
            {{ $formatter.YuanToThousandth(null, null, form.remainingMonthQuota, null) }}</i>
          </div>
        </div>

        <div class="info-item">
          <span class="label2">剩余额度百分比</span>
          <div class="demo-progress">
            <el-progress :percentage="Math.min(form.remainingMonthQuota  / form.monthQuota * 100, 100)"/>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>

  </el-dialog>
</template>

<script>
export default {
  name: "channelEdit",
  props: {
    show: Boolean,
    rowTable: {
      type: [Object, Array],
      required: false
    },
  },
  data() {
    return {
      form: {
        cardId: "",
        cardType: "",
        dailyQuota: "",
        deviceId: "",
        groupId: "",
        maxAmount: "",
        minAmount: "",
        monthQuota: "0",
        priority: "",
        receiverCardAccount: "",
        receiverCardOrganization: "",
        receiverName: "",
        remark: "",
        remainingMonthQuota: 0,
      },
      cardTypeList: [],
      cardUpstreamList: [],
      activeNames: ['1', '2'],
      dialogShow: false,
    };
  },
  created() {
    this.form = this.rowTable;
    this.dialogShow = this.show;
    // 卡片类型
    this.$axios.get("/card/selectCardTypeOptions", {params: {}}).then((res) => {
      if (res.code === 200) {
        this.cardTypeList = res.data;
      }
    });
    // 卡片上游
    this.$axios.get("/card/selectCardOrganizationOptions", {params: {}}).then((res) => {
      if (res.code === 200) {
        this.cardUpstreamList = res.data;
      }
    });
  },
  methods: {
    closeDialog() {
      this.dialogShow = false;
      this.$emit("update:show", false);
    },
    getCardTypeName(value) {
      return this.cardTypeList.filter(x => x.value === value)[0]?.name;
    },
    getReceiverCardOrganizationName(value) {
      return this.cardUpstreamList.filter(x => x.value === value)[0]?.name;
    },
  }
};
</script>

<style scoped>
.quota-info-item {
  font-size: 14px;
  display: flex;
  align-items: center;
}

.info-item {
  margin-bottom: 12px;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.label {
  width: 85px;
  text-align: left;
  font-weight: bold;
  color: #666;
}

.label2 {
  width: 140px;
  text-align: left;
  font-weight: bold;
  color: #666;
}

.value {
  flex: 1;
}

.orderStyle {
  font-size: 14px;
  color: #333;
  line-height: 1.8;
}

.detail-right {
  display: flex;
  gap: 4px;
  align-items: center;

  .el-icon-document-copy {
    cursor: pointer;
  }
}

</style>
